import React from 'react';
import './Svg.scss';
const Name = () => {
  return (
    <div>
      <svg
        width="100%"
        height="95"
        viewBox="0 0 578.3 73.4"
        xmlns="http://www.w3.org/2000/svg"
        className="svgh"
      >
        <g
          id="svgGroup"
          stroke-linecap="round"
          fill-rule="evenodd"
          font-size="9pt"
          stroke="#43556e"
          stroke-width="0.25mm"
          fill="#63e6d0"
        >
          <path
            className="tp2"
            d="M 9.5 1.1 L 6.9 17.4 L 48.6 71.4 L 51.2 55.1 L 9.5 1.1 Z M 48.6 71.4 L 58.4 71.4 L 58.4 1.1 L 44.7 1.1 L 44.7 58.2 L 48.6 71.4 Z M 13.6 71.4 L 0 71.4 L 0 1.1 L 9.5 1.1 L 13.6 14.7 L 13.6 71.4 Z"
            id="0"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 86.3 71.4 L 72.7 71.4 L 72.7 1.1 L 86.3 1.1 L 86.3 71.4 Z"
            id="1"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 94.2 60.8 L 103.2 51.8 A 24.003 24.003 0 0 0 107.582 56.294 A 21.072 21.072 0 0 0 110.4 58.15 Q 114.5 60.4 120.4 60.4 Q 124.287 60.4 127.018 59.271 A 10.591 10.591 0 0 0 128.85 58.3 Q 131.88 56.28 131.995 52.78 A 8.483 8.483 0 0 0 132 52.5 A 9.275 9.275 0 0 0 131.725 50.184 A 6.755 6.755 0 0 0 130.2 47.3 A 13.085 13.085 0 0 0 127.811 45.24 A 17.688 17.688 0 0 0 125.45 43.9 A 50.034 50.034 0 0 0 121.528 42.248 A 61.139 61.139 0 0 0 118.95 41.35 Q 115.4 40.2 111.85 38.7 Q 108.3 37.2 105.35 34.95 A 16.415 16.415 0 0 1 100.948 29.805 A 19.208 19.208 0 0 1 100.6 29.15 A 15.408 15.408 0 0 1 99.323 25.485 Q 98.947 23.779 98.841 21.795 A 29.971 29.971 0 0 1 98.8 20.2 Q 98.8 13.8 101.9 9.3 A 19.52 19.52 0 0 1 109.246 2.951 A 23.668 23.668 0 0 1 110.4 2.4 Q 115.8 0 122.6 0 A 33.142 33.142 0 0 1 130.257 0.855 A 27.81 27.81 0 0 1 135.6 2.7 A 30.264 30.264 0 0 1 141.461 6.244 A 25.309 25.309 0 0 1 145.1 9.7 L 136.1 18.7 Q 133.219 15.54 130.208 13.935 A 15.922 15.922 0 0 0 129.75 13.7 A 15.556 15.556 0 0 0 124.639 12.227 A 19.333 19.333 0 0 0 122.4 12.1 A 19.891 19.891 0 0 0 119.531 12.294 Q 118.045 12.511 116.829 12.971 A 9.071 9.071 0 0 0 115 13.9 A 5.734 5.734 0 0 0 112.373 18.028 A 7.669 7.669 0 0 0 112.3 19.1 Q 112.3 22 114.1 23.8 Q 115.788 25.488 118.486 26.736 A 22.009 22.009 0 0 0 118.85 26.9 A 71.577 71.577 0 0 0 122.565 28.409 A 89.629 89.629 0 0 0 125.35 29.4 Q 128.9 30.6 132.45 32.1 Q 136 33.6 138.95 36 A 17.164 17.164 0 0 1 143.047 40.901 A 20.451 20.451 0 0 1 143.7 42.15 Q 145.261 45.402 145.468 49.97 A 31.549 31.549 0 0 1 145.5 51.4 A 22.346 22.346 0 0 1 144.489 58.288 A 17.822 17.822 0 0 1 138.6 66.8 Q 132.563 71.7 122.623 72.313 A 47.501 47.501 0 0 1 119.7 72.4 A 41.678 41.678 0 0 1 112.964 71.884 Q 108.648 71.177 105.15 69.5 A 31.358 31.358 0 0 1 97.047 63.834 A 38.769 38.769 0 0 1 94.2 60.8 Z"
            id="2"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 163.1 71.4 L 148.9 71.4 L 177.2 1.1 L 188.3 1.1 L 216.5 71.4 L 202 71.4 L 180.2 13.7 L 185.2 13.7 L 163.1 71.4 Z M 201.7 58.3 L 163.9 58.3 L 163.9 46.9 L 201.7 46.9 L 201.7 58.3 Z"
            id="3"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 247.6 71.4 L 233.9 71.4 L 233.9 2.6 L 247.6 2.6 L 247.6 71.4 Z M 270 13.2 L 211.5 13.2 L 211.5 1.1 L 270 1.1 L 270 13.2 Z"
            id="4"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 310.9 71.4 L 297.3 71.4 L 297.3 1.1 L 310.9 1.1 L 310.9 71.4 Z"
            id="6"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 318.8 60.8 L 327.8 51.8 A 24.003 24.003 0 0 0 332.182 56.294 A 21.072 21.072 0 0 0 335 58.15 Q 339.1 60.4 345 60.4 Q 348.887 60.4 351.618 59.271 A 10.591 10.591 0 0 0 353.45 58.3 Q 356.48 56.28 356.595 52.78 A 8.483 8.483 0 0 0 356.6 52.5 A 9.275 9.275 0 0 0 356.325 50.184 A 6.755 6.755 0 0 0 354.8 47.3 A 13.085 13.085 0 0 0 352.411 45.24 A 17.688 17.688 0 0 0 350.05 43.9 A 50.034 50.034 0 0 0 346.128 42.248 A 61.139 61.139 0 0 0 343.55 41.35 Q 340 40.2 336.45 38.7 Q 332.9 37.2 329.95 34.95 A 16.415 16.415 0 0 1 325.548 29.805 A 19.208 19.208 0 0 1 325.2 29.15 A 15.408 15.408 0 0 1 323.923 25.485 Q 323.547 23.779 323.441 21.795 A 29.971 29.971 0 0 1 323.4 20.2 Q 323.4 13.8 326.5 9.3 A 19.52 19.52 0 0 1 333.846 2.951 A 23.668 23.668 0 0 1 335 2.4 Q 340.4 0 347.2 0 A 33.142 33.142 0 0 1 354.857 0.855 A 27.81 27.81 0 0 1 360.2 2.7 A 30.264 30.264 0 0 1 366.061 6.244 A 25.309 25.309 0 0 1 369.7 9.7 L 360.7 18.7 Q 357.819 15.54 354.808 13.935 A 15.922 15.922 0 0 0 354.35 13.7 A 15.556 15.556 0 0 0 349.239 12.227 A 19.333 19.333 0 0 0 347 12.1 A 19.891 19.891 0 0 0 344.131 12.294 Q 342.645 12.511 341.429 12.971 A 9.071 9.071 0 0 0 339.6 13.9 A 5.734 5.734 0 0 0 336.973 18.028 A 7.669 7.669 0 0 0 336.9 19.1 Q 336.9 22 338.7 23.8 Q 340.388 25.488 343.086 26.736 A 22.009 22.009 0 0 0 343.45 26.9 A 71.577 71.577 0 0 0 347.165 28.409 A 89.629 89.629 0 0 0 349.95 29.4 Q 353.5 30.6 357.05 32.1 Q 360.6 33.6 363.55 36 A 17.164 17.164 0 0 1 367.647 40.901 A 20.451 20.451 0 0 1 368.3 42.15 Q 369.861 45.402 370.068 49.97 A 31.549 31.549 0 0 1 370.1 51.4 A 22.346 22.346 0 0 1 369.089 58.288 A 17.822 17.822 0 0 1 363.2 66.8 Q 357.163 71.7 347.223 72.313 A 47.501 47.501 0 0 1 344.3 72.4 A 41.678 41.678 0 0 1 337.564 71.884 Q 333.248 71.177 329.75 69.5 A 31.358 31.358 0 0 1 321.647 63.834 A 38.769 38.769 0 0 1 318.8 60.8 Z"
            id="7"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 394.4 71.4 L 380.8 71.4 L 380.8 1.1 L 394.4 1.1 L 394.4 71.4 Z M 426.6 71.4 L 390.8 71.4 L 390.8 59.3 L 426.6 59.3 L 426.6 71.4 Z"
            id="8"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 443.3 71.4 L 429.1 71.4 L 457.4 1.1 L 468.5 1.1 L 496.7 71.4 L 482.2 71.4 L 460.4 13.7 L 465.4 13.7 L 443.3 71.4 Z M 481.9 58.3 L 444.1 58.3 L 444.1 46.9 L 481.9 46.9 L 481.9 58.3 Z"
            id="9"
            vector-effect="non-scaling-stroke"
          />
          <path
            className="tp2"
            d="M 518.6 71.4 L 505 71.4 L 505 1.1 L 514.6 1.1 L 543.1 46.7 L 537.6 46.7 L 566 1.1 L 575.6 1.1 L 575.6 71.4 L 562.1 71.4 L 562.1 24.4 L 564.7 25.2 L 544.9 57 L 535.7 57 L 515.9 25.2 L 518.6 24.4 L 518.6 71.4 Z"
            id="10"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </svg>
    </div>
  );
};

export default Name;
